import { faSort, faSortDown, faSortUp } from '@fortawesome/pro-solid-svg-icons';

export function getSortIcon(sort: false | 'asc' | 'desc') {
  if (sort === 'asc') return faSortUp;
  if (sort === 'desc') return faSortDown;
  return faSort;
}
